import React from 'react';
import { useNavigate } from 'react-router-dom';

import { handleLogout } from '../../../../../../utils/global';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';
import IconContainer from '../../../../../common-components/FtuxComponent/IconContainer';
import ModalComponent from '../../../../../common-components/ModalComponent/ModalComponent';

export default function CancellationModal({ show }) {
  const navigate = useNavigate();

  return (
    <ModalComponent
      show={show}
      width={480}
      outsideClickClose={false}
      style={{ padding: '32px' }}
      bodyStyle={{ padding: 0 }}>
      <div className="warning-modal modal-main-content">
        <IconContainer icon="🙁" bgColor="rgba(229, 142, 9, 0.10)" />
        <h2 style={{ marginBottom: '24px' }}>Your subscription is cancelled</h2>
        <p style={{ paddingBottom: '24px' }}>
          We wish you the best with your brand and your influencer efforts in the future.
        </p>
        <p style={{ paddingBottom: '24px' }}>
          Feel free to check in to SARAL in the next 3 months, we keep building features that might make it relevant for
          you again.
        </p>
        <p style={{ paddingBottom: '8px', width: '100%' }}>Crush it!</p>
        <div className="modal-footer-button-container">
          <ButtonComponent onClick={handleLogout} variant="secondary" style={{ padding: '10px 18px' }}>
            Log Out
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}
